/**
 * LogoBackground — Logo translúcido fixo ao fundo da página.
 * Usado em todas as páginas de aluno (exceto admin e instrutor).
 * opacity-[0.35] = 35%
 */
export default function LogoBackground() {
  return (
    <div
      className="fixed inset-0 z-0 flex items-center justify-center pointer-events-none select-none"
      aria-hidden="true"
    >
      <img
        src="/images/logotipo.jpg"
        alt=""
        className="w-auto h-[55vh] max-w-[70vw] object-contain opacity-[0.35]"
        draggable={false}
      />
    </div>
  );
}
